import React, { useState, createContext, useCallback, Fragment, useEffect } from 'react';

import { Transition } from '@headlessui/react';
import { AlertTriangle, X } from 'lucide-react';

export const ToastContext = createContext(null);

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  
  const addToast = useCallback((message) => {
    setToast({ id: Date.now(), message });
  }, []);
  
  const removeToast = useCallback(() => {
    setToast(null);
  }, []);
  
  useEffect(() => {
    if (!toast) {
      return;
    }
    
    const timerId = setTimeout(() => {
      removeToast();
    }, 10000);
    
    return () => {
      clearTimeout(timerId);
    };
  }, [toast, removeToast]);
  
  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="w-full max-w-[350px] absolute top-5 right-5 z-50">
        <Transition
          as={Fragment}
          show={!!toast}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
            <div className="p-4">
              <div className="flex items-start">
                <AlertTriangle className="h-6 w-6 text-yellow-500" aria-hidden="true" />
                
                <div className="ml-3 w-0 flex-1">
                  <div className="flex justify-between items-start">
                    <p className="text-sm font-medium text-gray-900">Request Limit Reached</p>
                    
                    <button
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={removeToast}
                    >
                      <span className="sr-only">Close</span>
                      
                      <X className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                  
                  <div className="mt-1">
                    <p className="text-sm text-gray-500">{toast?.message}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </ToastContext.Provider>
  );
};

export default ToastProvider
